import { IoMdArrowForward } from "react-icons/io";
import React, { useState, useContext } from 'react'
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import loginimage from '../assets/images/loginImage.png';
import logo from '../assets/images/logo.png';
import '../assets/styles/login.css';
import { MdOutlineEmail } from "react-icons/md";
import { FiLock } from "react-icons/fi";
import CircleOverlay from '../components/layout/CircleOverlay';
import { AuthContext } from '../features/auth/AuthProvider';
import {useLogin} from '../hooks/auth/login';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, isAuthenticated } = useContext(AuthContext);

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const loginMutation = useLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await loginMutation.mutateAsync({ email, password });
      if (response?.success && response?.data?.accessToken && response?.data?.refreshToken) {
        await login({
          accessToken: response.data.accessToken,
          refreshToken: response.data.refreshToken,
        });
        toast.success('Login successful!');
        navigate('/dashboard');
      } else {
        toast.error('Login failed: Invalid response');
        console.error('Login failed: Invalid response', response);
      }
    } catch (err) {
      toast.error('Login failed. Please check your credentials.');
      console.error('Login failed', err);
    }
  };


  return (
    <div className="login-container">
      <div className="login-left-column">
        <div className='image-login'>
        <img src={loginimage} alt="Login" className="login-image" />
      </div>
      </div>
      <div className="login-right-column">
      <CircleOverlay />
        <div className="login-form-wrapper">
          <div className="login-header">
            <img src={logo} alt="Indeva Logo"  />
          </div>
          
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <span className="input-icon"><MdOutlineEmail style={{color:'#004996'}} /></span>
              <input
                type="email"
                placeholder="Enter Your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="login-input"
                required
              />
            </div>

            <div className="input-group">
              <span className="input-icon"><FiLock style={{color:'#004996'}}/></span>
              <input
                type="password"
                placeholder="Enter Your Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
                required
              />
            </div>

            <div className="forgot-password">
                <button type="button" className="forgot-password-link" tabIndex={0} style={{background: 'none', border: 'none', color: '#f4f4f5ff', textDecoration: 'underline', cursor: 'pointer', padding: 0}}>
                  Forget Password ?
                </button>
            <button type="submit" className="login-button" >
              <IoMdArrowForward style={{color: '#004996'}}/>
            </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  )
}

export default Login